enum MidRollPositions {
  Start = 'start',
  Middle = 'middle',
  End = 'end'
};

export default MidRollPositions;
